import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { CategoryLink } from '../form-elements/Link';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { categoryUrlSelector } from '../../../modules/selectors/url';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import { standortUrlSelector } from '../../../modules/selectors/url';
import { apiClient } from '../../../helpers/apiHelperV2';
import { useHistory } from 'react-router-dom';

function ShopMenuList({ className = 'uk-nav uk-nav-default uk-nav-parent-icon', 'data-uk-nav': dataUkNav, categories, closeSidebar }) {
    const [hasOfferCategory, setHasOfferCategory] = useState(false);
    const [offerCategory, setOfferCategory] = useState({});
    const categoryUrl = useSelector(categoryUrlSelector);
    const markenStandort = useSelector(markenStandortSelector);
    const standortUrl = useSelector(standortUrlSelector);
    const [activeCategory, setActiveCategory] = useState(null)
    const history = useHistory()
    const isLinkActive = category => {
        return category.url === categoryUrl || category?.subCategories?.find(subCategory => subCategory.url === categoryUrl);
    };

    const isActiveCategory = category => {
        return  activeCategory === category._id
    }

    const handleCategoryPress = (e, hasSubCategories, category) => {
        e.preventDefault()
        if(e.key === "Enter"){
            if(hasSubCategories){
                setActiveCategory(oldState => oldState === category._id ? null : category._id)
            } else {
                closeSidebar()
            }
        }
    }

    useEffect(() => {
        async function fetchOffers() {
            const { data } = await apiClient.get(`/api/v1/standorte/${standortUrl}/angebote`)
            return data
        }
        fetchOffers().then((data) => {
            if (data?.length) {
                setHasOfferCategory(true)
            }
        }).catch((err) => console.log("error", err))

        if (categories) {
            let offerCategory = categories.find((category) => category.url === "angebote")
            if (offerCategory) {
                setOfferCategory(offerCategory);
            }
        }
    }, [categories, standortUrl])

    return (
        <ul className={className} data-uk-nav={dataUkNav}>
            {hasOfferCategory &&
                <li key={offerCategory._id} className={classnames({ 'uk-parent': false, 'uk-active': isLinkActive(offerCategory) })} onClick={closeSidebar}>
                    <strong>
                        <CategoryLink category={offerCategory} className="uk-text-bold strong-text">{offerCategory.title}
                        </CategoryLink>
                    </strong>
                </li>
            }
            {categories ? categories.filter(category => {
                return !category.subCategories.every(subCategory => {
                    return markenStandort.categoryBlacklist.map(cat => String(cat._id)).includes(String(subCategory._id))
                })
            }).map(category => {
                const hasSubCategories = category.subCategories.length >= 1;
                return (
                    <li
                        role="tab"
                        tabIndex={0}        
                        key={category._id}
                        className={classnames({
                            'uk-parent': hasSubCategories,
                            'uk-active': isLinkActive(category),
                        })}
                        aria-selected={isActiveCategory(category)}
                        aria-controls={`${category.url}-subcategories`}
                        id={`${category.url}-tab`}
                        style={{cursor: "pointer"}}
                        onKeyPress={(e) => handleCategoryPress(e,hasSubCategories,category)}
                        onClick={hasSubCategories ? () => setActiveCategory(oldState => oldState === category._id ? null : category._id) : closeSidebar}
                    >  
                    <div className="category_button">
                            <span className={classnames({
                                "uk-active": isActiveCategory(category),
                            })}>
                                {category.title}
                            </span>
                            <span uk-icon={isActiveCategory(category) ? "chevron-down" : "chevron-left"}></span>
                    </div>
                        {hasSubCategories && isActiveCategory(category) && (
                            <ul className="uk-nav-sub" id={`${category.url}-subcategories`} role="tabpanel" aria-labelledby={`${category.url}-tab`}>
                                {/* <li
                                    className={classnames({
                                        'uk-parent': category,
                                        'uk-active': category.url === categoryUrl,
                                    })}
                                    onClick={closeSidebar}
                                    onKeyPress={() => {closeSidebar(); history.push(`${category.url}`)}}
                                >
                                    <CategoryLink category={category}>Zur Kategorie</CategoryLink>
                                </li> */}
                                {_.sortBy(category.subCategories, ['title']).map((subCategory, index) => (
                                    <li
                                        key={index}
                                        onClick={closeSidebar}
                                        onKeyPress={() => {closeSidebar(); history.push(`${subCategory.url}`)}}
                                        className={classnames({
                                            'uk-parent': category,
                                            'uk-active': subCategory.url === categoryUrl,
                                        })}
                                    >
                                        <CategoryLink category={subCategory}>{subCategory.title}</CategoryLink>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                );
            })
                :
                <></>}
        </ul>
    );
}

export default ShopMenuList;
